﻿import { api } from './_api-client';

export const ttAuth = (id: number) => {
  return api.post<{ url: Url }>(`/Social/TikTok/Auth?finalCutId=${id}`);
};

export const ttPublish = (videoUrl: Url, token: string) => {
  const model = {
    tikTokAccessToken: token,
    videoUrl: videoUrl,
  };
  return api.post<{ code: number; body: string }>('/Social/TikTok/Upload', model).then((res) => {
    if (res.data.code === 401) {
      return Promise.reject(401);
    }
  });
};
